import React from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

const options = {
    sortIndicator: true,
    hideSizePerPage: false,
    paginationSize: 3,
    hidePageListOnlyOnePage: false,
    clearSearch: true,
    alwaysShowAllBtns: true,
    withFirstAndLast: true,
};

const statusType = {
    PAID: "PAID",
    NOT_PAID: "NOT PAID",
    PARTIALLY_PAID: "PARTIALLY PAID",
    CANCELLED: "CANCELLED",
    unKnow: "UnKnow",
};

const PartyDueBodyDetails = ({ data }) => {

    const enumFormatter = (cell, row, enumObject) => {
        return enumObject[cell];
    };


    return (
        <div>

            <BootstrapTable
                data={data}
                version="4"
                condensed={true}
                striped
                hover
                pagination
                search
                options={options}
                exportCSV
                csvFileName="sales_summary.csv"
            >
                <TableHeaderColumn
                    isKey
                    dataField="id"
                    export={false}
                    hidden={true}
                >
                    ID
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="beatName"
                    csvHeader="beatName"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    export={true}
                >
                    Beat Name
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="salesPersonName"
                    export={true}
                    csvHeader="Sales Person"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}

                >
                    Sales Person
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="billDate"
                    csvHeader="billDate"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                    editable={true}
                >
                    Bill Date
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="invoiceNumber"
                    csvHeader="invoiceNumber"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                    editable={true}
                >
                    Invoice Number
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="partyName"
                    csvHeader="partyName"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                    editable={true}
                >
                    Party Name
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="paymentType"
                    csvHeader="paymentType"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                    editable={true}
                >
                    Payment Type
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="netSales"
                    csvHeader="netSales"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                    editable={true}
                >
                    Amount
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="balance"
                    csvHeader="balance"
                    filter={{ type: "TextFilter", delay: 1000 }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                    editable={true}
                >
                    Balance Due
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="status"
                    csvHeader="status"
                    //  filter={{ type: "TextFilter", delay: 1000 }}
                    filterFormatted
                    dataFormat={enumFormatter}
                    formatExtraData={statusType}
                    filter={{
                        type: "SelectFilter",
                        options: statusType,
                        condition: "eq",
                    }}
                    dataSort
                    tdStyle={{ whiteSpace: "normal" }}
                    thStyle={{ whiteSpace: "normal" }}
                >
                    Status
                </TableHeaderColumn>

            </BootstrapTable>
        </div>
    );
};

export default PartyDueBodyDetails;


// WEBPACK FOOTER //
// ./src/components/CustomComponents/PartyDueBodyDetails.js